@if (commissionerData; as commissioner) {
    <div class="accordion-container">
        <cll-card-divider />
        <div class="accordion-map">
            <google-map [options]="options" (mapInitialized)="initMap($event, commissionerData)" width="100%" #map>
                @if (commissionerData.address.lat && commissionerData.address.lng) {
                    <map-advanced-marker #markerElem="mapAdvancedMarker" [title]="commissionerData.address.post_code"
                                        [position]="{ lat: +commissionerData.address.lat, lng: +commissionerData.address.lng }" />
                }
            </google-map>
        </div>
        <div class="accordion-row-field">
            <app-accordion-item [label]="'Address line 1'" [data]="commissioner.address.street_1"/>
        </div>
        <div class="accordion-row-field">
            <app-accordion-item [label]="'Address line 2'" [data]="commissioner.address.street_2"/>
        </div>
        <div class="accordion-row-field">
            <app-accordion-item [label]="'Town'" [data]="commissioner.address.town"/>
        </div>
        <div class="accordion-row-field">
            <app-accordion-item [label]="'County'" [data]="commissioner.address.county"/>
        </div>
        <div class="accordion-row-field">
            <app-accordion-item [label]="'Country'" [data]="commissioner.address.country"/>
        </div>
        <div class="accordion-row-field">
            <app-accordion-item [label]="'Postcode'" [data]="commissioner.address.post_code"/>
        </div>
        <div class="accordion-row-field">
            <app-accordion-item [label]="'Address additional comments'" [data]="commissioner.address.additional_comments"/>
        </div>
        <div class="accordion-row-field">
            <app-accordion-item [label]="'Is the property hard to reach'" [data]="commissioner.address.hard_to_reach ? 'Yes' : 'No'"/>
        </div>
        <div class="accordion-row-field">
            <app-accordion-item [label]="'Email address'" [data]="commissioner.email"/>
        </div>
        @if (commissionerData.contact_numbers; as contactNumbers) {
            @if (contactNumbers.length > 0) {
                @for (contactNumber of contactNumbers; track contactNumber.id) {
                    <div class="accordion-row-field">
                        <app-accordion-item [label]="contactNumber.type" [data]="contactNumber.number"/>
                    </div>
                }
            }
        }


        @if (commissioner.status){
            <cll-card-footer>
                <button cll-tonal-button (click)="editContactAddressDetails()">
                    <cll-icon cllButtonIcon type="outlined" [size]="20">edit</cll-icon>
                    Edit
                </button>
            </cll-card-footer>
        }
    </div>
}
